import { Grid, Skeleton } from "@mui/material";
import { Box, Container } from "@mui/system";
import React from "react";

export default function ImageMasonry({data}){

    //console.log(data)

    return(
        <Container maxWidth='xl'>
            {data?
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4} container spacing={2}>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'150px',
                                    width:'100%',
                                    backgroundImage:'url('+data[0].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'150px',
                                    width:'100%',
                                    backgroundImage:'url('+data[1].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'150px',
                                    width:'100%',
                                    backgroundImage:'url('+data[2].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={4} container spacing={2}>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'316px',
                                    width:'100%',
                                    backgroundImage:'url('+data[3].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'150px',
                                    width:'100%',
                                    backgroundImage:'url('+data[4].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={4} container spacing={2}>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'150px',
                                    width:'100%',
                                    backgroundImage:'url('+data[5].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Box
                                sx={{
                                    height:'316px',
                                    width:'100%',
                                    backgroundImage:'url('+data[6].image.url+')',
                                    backgroundSize:'cover',
                                    backgroundPosition:'center'
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            :
                <Grid container spacing={2}>
                    {Array(6).fill(0).map(()=>{
                        return(
                            <Grid item xs={12} md={4}>
                                <Skeleton
                                    variant="rectangular"
                                    height={150}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            }
        </Container>
    );
}